export const GET_PLANS_REQUEST = 'SUBSCRIPTIONS:GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'SUBSCRIPTIONS:GET_PLANS_SUCCESS';
export const GET_PLANS_FAILURE = 'SUBSCRIPTIONS:GET_PLANS_FAILURE';
export const SET_PLAN = 'SUBSCRIPTIONS:SET_PLAN';
